import {
    HTTP_INTERCEPTORS,
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { SessionTimeoutService } from './services/session-timeout.service';
import { AppService } from './services/app.service';

@Injectable()
export class HttpsRequestInterceptor implements HttpInterceptor {
    constructor(private router: Router,
        private appService: AppService,
        public sessionTimeoutService: SessionTimeoutService) { }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.endsWith("/configuration")) {
            return next.handle(req);
        }
        return next.handle(req).do((event: HttpEvent<any>) => {
        }, (err: any) => {
            if (err instanceof HttpErrorResponse) {
                if (err.status === 401 || err.status === 403 || err.status === 406) {
                    this.appService.getAuthenticationEntryPoint().then(entryPoint => {
                        window.location.href = entryPoint;
                    });
                }
            }
        });
    }
}
@NgModule({
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpsRequestInterceptor, multi: true }
    ]
})
export class InterceptorModule { }



// WEBPACK FOOTER //
// ./client/views/app.interceptor.ts